import { make } from 'vuex-pathify';
import { LoanPoolService } from '@/modules/loanpro/services/loan-pool.service.js';
import Logger from '@/lib/logger.js';

export const state = {
  progressTabs: [
    {
      id: 'all',
      title: 'All',
      value: 'all'
    },
    {
      id: 'in-progress',
      title: 'In Progress',
      value: [
        'in-progress',
        'interview',
        'waiver request rejected',
        'approval request rejected',
        'waiver request granted',
        'disbursement rejected'
      ]
    },
    {
      id: 'reviews',
      title: 'Loan Review',
      value: ['loan review']
    },
    {
      id: 'approvals',
      title: 'Pending Approval',
      value: ['waiver requested', 'approval requested']
    },
    {
      id: 'securities check',
      title: 'Securities Check',
      value: ['securities check']
    },
    {
      id: 'disbursements',
      title: 'Pending Disbursement',
      value: ['approved', 'partially disbursed']
    }
  ],

  assignmentTabs: [
    { title: 'All', value: 'all' },
    { title: 'Assigned', value: 'assigned' },
    { title: 'Unassigned', value: 'unassigned' }
  ]
};

export const mutations = {
  ...make.mutations(state)
};

export const getters = {
  ...make.getters(state)
};

export const actions = {
  async terminateLoan(_, payload) {
    try {
      const service = new LoanPoolService();
      return await service.terminateLoan(payload);
    } catch (error) {
      Logger.error('Error While Terminating Loan');
      throw error;
    }
  }
};
